import React from 'react';
import storeManager from '../../../store/StoreManager';
import Draggable from 'react-draggable';
import { uiProperties } from '../../utils/TransformToolUtils';
import appParameters from '../../utils/AppParameters';
import zoomUtils from '../../utils/ZoomUtils';
import configuration from '../../../constants/Configuration';

export const ZoomTransformTool = React.createClass({
    getInitialState() {
        const hotspot = this.getCurrentHotspot();
        zoomUtils.currentHotspot = hotspot;
        zoomUtils.currentBackgroundUid = this.props.backgroundModel.uuid;

        return {
            x: hotspot.x,
            y: hotspot.y,
            width: hotspot.width,
            height: hotspot.height,
            startX: -1,
            startY: -1,
            startWidth: -1,
            startHeight: -1
        };
    },
    zoomEventListener(e){
        const interval = 10;
        const aspectRatio = 9/16
        let hasChanged = false;

        if (e.detail === "zoomIn") {
            this.setState({width: this.state.width + interval, height: this.state.height + aspectRatio * interval});
            hasChanged = true;

        } else if (e.detail === "zoomOut") {
            if (this.state.width > interval && this.state.height > aspectRatio * interval) {
                this.setState({width: this.state.width - interval, height: this.state.height - aspectRatio * interval});
                hasChanged = true;
            }
        } else if (e.detail === "left") {
            this.setState({x: this.state.x - interval});
            hasChanged = true;
        } else if (e.detail === "right") {
            this.setState({x: this.state.x + interval});
            hasChanged = true;
        } else if (e.detail === "up") {
            this.setState({y: this.state.y - interval});
            hasChanged = true;
        } else if (e.detail === "down") {
            this.setState({y: this.state.y + 20});
            hasChanged = true;
        }

        if(hasChanged) {
            this.updateHotspot();
        }
    },
    componentDidMount(){
        document.addEventListener("ZoomTransformEvent", this.zoomEventListener);
    },
    componentWillUnmount(){
        document.removeEventListener("ZoomTransformEvent", this.zoomEventListener)
    },
    getCurrentHotspot() {
        const hotspot = this.props.backgroundModel.hotSpot;
        var hotspotModel = {};

        if (hotspot == undefined || hotspot == '') {
            hotspotModel.width = 400;
            hotspotModel.height = 400 * 9 / 16;
            hotspotModel.x = 200;
            hotspotModel.y = 450 / 2 - hotspotModel.height / 2;
        } else {
            hotspotModel.x = hotspot.x;
            hotspotModel.y = hotspot.y;
            hotspotModel.width = hotspot.width;
            hotspotModel.height = hotspot.height;
        }

        return hotspotModel;
    },
    refreshInitialPosition() {
        setTimeout(this.updateInitialPosition, 1);
    },
    updateInitialPosition() {
        const hotspot = this.getCurrentHotspot();
        zoomUtils.currentHotspot = hotspot;
        zoomUtils.currentBackgroundUid = this.props.backgroundModel.uuid;

        this.setState({
            x: hotspot.x,
            y: hotspot.y,
            width: hotspot.width,
            height: hotspot.height
        });

        zoomUtils.updateInitialPosition = false;
    },
    onScaleStart(e) {
        e.preventDefault();

        this.setState({
            startX: this.state.x,
            startY: this.state.y,
            startWidth: this.state.width,
            startHeight: this.state.height
        });

        zoomUtils.updateInitialPosition = false;
    },
    onScaleDrag(e, coreEvent) {
        e.preventDefault();

        let id = coreEvent.node.id;
        var x = this.state.startX;
        var y = this.state.startY;
        var width = this.state.startWidth;
        var height = this.state.startHeight;
        const minWidth = 100;

        switch (id) {
            case 'topLeft':
            {
                x = this.state.startX + coreEvent.lastX / this.scaleFactor();
                y = this.state.startY + coreEvent.lastY / this.scaleFactor();
                width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();

                break;
            }

            case 'topRight':
            {
                width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();
                y = this.state.startY + coreEvent.lastY / this.scaleFactor();

                break;
            }

            case 'bottomLeft':
            {
                x = this.state.startX + coreEvent.lastX / this.scaleFactor();
                width = this.state.startWidth - coreEvent.lastX / this.scaleFactor();

                break;
            }

            case 'bottomRight':
            {
                width = this.state.startWidth + coreEvent.lastX / this.scaleFactor();

                break;
            }
        }

        height = width * 9 / 16;

        if (x >= 0 && width >= minWidth && x + width <= configuration.CANVAS_WIDTH && y + height <= configuration.CANVAS_HEIGHT && y >= 0) {
            this.setState({
                x,
                y,
                width,
                height
            });
        }
    },
    onScaleStopped() {
        this.updateHotspot();
    },
    updateHotspot() {
        var hotspot = {};
        hotspot.x = this.state.x;
        hotspot.y = this.state.y;
        hotspot.width = this.state.width;
        hotspot.height = this.state.height;

        zoomUtils.currentHotspot = hotspot;
        zoomUtils.currentBackgroundUid = this.props.backgroundModel.uuid;
    },
    onMoveStart(e) {
        e.preventDefault();

        this.setState({
            startX: this.state.x,
            startY: this.state.y
        });

        zoomUtils.updateInitialPosition = false;
    },
    onMoveDrag(e, coreEvent) {
        e.preventDefault();

        var x = this.state.startX + coreEvent.lastX / this.scaleFactor();
        var y = this.state.startY + coreEvent.lastY / this.scaleFactor();

        if (x < 0)
            x = 0;

        if ((x + this.state.width) > configuration.CANVAS_WIDTH)
            x = configuration.CANVAS_WIDTH - this.state.width;

        if (y < 0)
            y = 0;

        if ((y + this.state.height) > configuration.CANVAS_HEIGHT)
            y = configuration.CANVAS_HEIGHT - this.state.height;

        this.setState({
            x,
            y
        });
    },
    onMoveStopped() {
        this.updateHotspot();
    },
    scaleFactor() {
        const canvasScale = this.props.scaleProperties.scale;
        return canvasScale;
    },
    isVisible() {
        const state = storeManager.getState();
        const showZoomSlides = state.menu.showZoomSlides;

        if (showZoomSlides == undefined || showZoomSlides == false || this.props.backgroundModel == undefined)
            return false;
        else
            return true;
    },
    render() {
        if (this.isVisible() == false)
            return (<g></g>);

        if (zoomUtils.updateInitialPosition == true)
            this.refreshInitialPosition();

        const x = this.state.x;
        const y = this.state.y;
        const width = this.state.width;
        const height = this.state.height;
        const scale = this.props.scaleProperties.scale;

        let pathPoints = `M0 0 L${width} 0 L${width} ${height} L0 ${height} Z`;

        let cornerFill = uiProperties.CORNER_FILL_INACTIVE;
        let cornerStroke = uiProperties.CORNER_STROKE_INACTIVE;

        const radius = uiProperties.RADIUS * 1.3 / scale;
        const bigRadius = uiProperties.RADIUS * 2 / scale;

        const canvasWidth = configuration.CANVAS_WIDTH;
        const canvasHeight = configuration.CANVAS_HEIGHT;

        return (
            <g transform={`translate(${x} ${y})`}>
                <rect x={-this.state.x} y={-this.state.y} width={this.state.x} height={canvasHeight} fill='#000000' fillOpacity={0.5}/>
                <rect x={this.state.width} y={-this.state.y} width={canvasWidth - this.state.x - this.state.width} height={canvasHeight} fill='#000000' fillOpacity={0.5}/>
                <rect x={0} y={- this.state.y} width={this.state.width} height={this.state.y} fill='#000000' fillOpacity={0.5}/>
                <rect x={0} y={this.state.height} width={this.state.width} height={canvasHeight - this.state.y - this.state.height} fill='#000000' fillOpacity={0.5}/>

                <path stroke={uiProperties.PATH_COLOR} strokeWidth={uiProperties.STROKE} fill="none" d={pathPoints}/>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMoveStart} onDrag={this.onMoveDrag} onStop={this.onMoveStopped}>
                    <rect x={0} y={0} width={this.state.width} height={this.state.height} fill='#000000' fillOpacity={0}/>
                </Draggable>

                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="topLeft" cx={0} cy={0} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="topRight" cx={width} cy={0} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="bottomRight" cx={width} cy={height} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onScaleStart} onDrag={this.onScaleDrag} onStop={this.onScaleStopped}>
                    <circle id="bottomLeft" cx={0} cy={height} r={radius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                </Draggable>

                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMoveStart} onDrag={this.onMoveDrag} onStop={this.onMoveStopped}>
                    <g>
                        <circle id="center" cx={width/2} cy={height/2} r={bigRadius} fill={cornerFill} strokeWidth={uiProperties.STROKE} stroke={cornerStroke}/>
                        <image xlinkHref={appParameters.RESOURCES_LOCATION() + 'assets/moveArrows.png'} x={width/2 - 8} y={height/2 - 8} width="16px" height="16px" preserveAspectRatio="none"/>
                    </g>
                </Draggable>
            </g>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/interactive/ZoomTransformTool.js
 **/